/**
 * Export cheerio (with )
 */

exports = module.exports = require('./lib/cheerio');

/*
  Export the version
*/

exports.version = require('./package.json').version;



//////////////////
// WEBPACK FOOTER
// ./node_modules/truncate-html/node_modules/cheerio/index.js
// module id = VpTt
// module chunks = 0 1 2